import { useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { authApi } from '@/api/auth';
import { useAuth } from '@/context/AuthContext';

export function VerifyOtpPage() {
  const { phone } = useParams<{ phone: string }>();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [digits, setDigits] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);

  const handleChange = (index: number, value: string) => {
    if (!/^\d?$/.test(value)) return;
    const next = [...digits];
    next[index] = value;
    setDigits(next);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }

    // Auto-submit when all digits filled
    if (value && index === 5) {
      const otp = [...next].join('');
      if (otp.length === 6) handleVerify(otp);
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && !digits[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleVerify = async (otp?: string) => {
    const code = otp || digits.join('');
    if (code.length !== 6 || !phone) return;
    setError('');
    setLoading(true);
    try {
      const res = await authApi.verifyOtp({ phone, otp: code });
      if (res.data?.token) {
        login(res.data.token);
        navigate('/', { replace: true });
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid OTP');
      setDigits(['', '', '', '', '', '']);
      inputsRef.current[0]?.focus();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '100dvh' }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700 }}>Verify OTP</h1>
        <p style={{ color: 'var(--text-secondary)', marginTop: 4, fontSize: 15 }}>
          Enter the 6-digit code sent to {phone}
        </p>
      </div>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', marginBottom: 24 }}>
        {digits.map((d, i) => (
          <input
            key={i}
            ref={(el) => { inputsRef.current[i] = el; }}
            className="input"
            style={{
              width: 48,
              height: 56,
              textAlign: 'center',
              fontSize: 22,
              fontWeight: 700,
              padding: 0,
            }}
            type="tel"
            inputMode="numeric"
            maxLength={1}
            value={d}
            onChange={(e) => handleChange(i, e.target.value)}
            onKeyDown={(e) => handleKeyDown(i, e)}
          />
        ))}
      </div>

      {error && <p style={{ color: 'var(--danger)', fontSize: 14, textAlign: 'center', marginBottom: 16 }}>{error}</p>}

      <button
        className="btn btn-primary btn-full"
        disabled={digits.join('').length !== 6 || loading}
        onClick={() => handleVerify()}
      >
        {loading ? 'Verifying...' : 'Verify'}
      </button>
    </div>
  );
}
